let mapper_options = {
  endpoint: 'email_shares',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      retailer: {
        foreignKey: 'retailer_id',
        localField: 'retailer'
      },
      share_setting: {
        foreignKey: 'share_setting_id',
        localField: 'share_setting'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('email_share', mapper_options)
}
